export const locales = {
    'receipt.need': 'Отпускается по рецепту',
    'blocked.phone': 'Доступно бронирование по телефону',
    'blocked.show_pharmacies': 'Показать аптеки',
    'blocked.add_disabled': 'Этот товар можно забронировать только по телефону',
    'product.not_in_stock': 'Товара нет в наличии в аптеках',
    'product.add_to_cart': 'Добавить в корзину',
    'product.in_cart': 'В корзине',
    'product.remove_from_cart': 'Удалить',
    'product.show_more': 'Показать полностью',
    'product.show_less': 'Свернуть',
    'product.analog_no_stock': 'Нет в наличии',
    'product.analog_phone_only': 'Только по телефону',
    'product.search_more': 'Найти больше вариантов',
}